/**
 * @desc 分配任务筛选库位
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.inventoryMaster.positionCodeSelected.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/inventoryMaster/positionCodeSelected`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
